import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { Storage } from '@ionic/storage';

import { PlayPage } from '../play/play'; 
import { HomePage } from '../home/home';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';
import { DataExchanger } from '../../providers/data-exchanger';

@Component({
  selector: 'page-versus',
  templateUrl: 'versus.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class VersusPage {
  difficulty: string;
  language: string;
  settingsChanged:boolean;

  constructor(public rubedoSideMenu: MenuController, public functions: Functions, public translate: TranslateService, public navCtrl: NavController, public userdataModel:UserdataModel, public dataExchanger:DataExchanger, private storage: Storage) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    
    this.difficulty = '';
    this.language = '';
    this.settingsChanged=false;
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillLeave(){
    //before the page leaves the viewport
    this.functions.setDifficulty();
    this.functions.setLanguage();
    if (this.settingsChanged) {
      this.dataExchanger.storeUserGamedataOnServer(true);
      console.log("Setting changed... saving on server");
    }
    this.settingsChanged=false;
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.getDifficulty();
    this.functions.getLanguage();
    this.settingsChanged=false;
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }
  /* --------- END LIFECYCLE --------- */

  startPlayVersusAI(){   
    this.functions.gamemodeVersusActive=true;
    this.navCtrl.push(PlayPage, {});
  }

  startPlayVersusPlayer(){
    // TODO controllare se il giocatore scelto esiste e notificarlo
  }

  changeSetting(settingType,value){
    this.settingsChanged=true;

    // Set settings in userdata is done here for in functions was not possibile due to circular reference problem
    switch (settingType) {
      case "gamemode":
        this.userdataModel.setSettingsCurrentGamemode(this.functions.gamemode);
        this.functions.setGameMode();
      break;

      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/versus/versus.ts